import ExecuteTransformCrmContactProcessRequestModelBase from '../_generated/modelBases/execute-transform-crm-contact-process-request-model-base';

export default class ExecuteTransformCrmContactProcessRequestModel extends ExecuteTransformCrmContactProcessRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
